/* 🤖 this file was generated by svg-to-ts */
export const mgcIconUpRegular: {
  name: 'up-regular';
  data: string;
} = {
  name: 'up-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.64 8.068c-.155.053-.585.466-3.131 3.007-2.271 2.266-2.974 2.991-3.05 3.143a1 1 0 0 0 .48 1.347c.22.1.589.097.821-.008.138-.062.771-.671 2.71-2.608L12 10.421l2.53 2.528c1.939 1.937 2.572 2.546 2.71 2.608.232.105.601.108.821.008a1 1 0 0 0 .48-1.347c-.076-.152-.778-.876-3.05-3.143-2.686-2.68-2.969-2.95-3.148-3.01a1.053 1.053 0 0 0-.703.003"/></svg>`
};
